import React from "react";
import { useState, useContext } from "react";
import Layout from "../../../Layouts/Layout";
import SearchFiberCompanyReq from "../../../Requests/FiberCompany/SearchFiberCompanyReq";
import FiberCompanyApi from "../../../API/FiberCompanyApi";

import { UserContext } from "../../../App";
import { useEffect } from "react";
import Swal from "sweetalert2";
import SearchOrgReq from "../../../Requests/Organizations/SearchOrgReq";
import OrgApi from "../../../API/OrgApi";
import { get } from "sortablejs";
import { Search } from "lucide-react";
import StringIntReq from "../../../Requests/StringIntReq";
import { use } from "react";
import FiberHouseApi from "../../../API/FiberHouseApi";
import { AudioRecorder } from "../../TeamAdmin/MapPage/components/NewLeadCard/AudioRecording";
import { FaSearch } from "react-icons/fa";
import FiberCompanySelector from "../../../components/FiberCompanySelector";
import FiberPlanSelector from "../../../components/FiberPlanSelector";
import OrganizationSelector from "../../../components/OrganizationSelector";
import UserSelector from "../../../components/UserSelector";
import { Pagination, PaginationItem } from "@mui/material";
import { BiLeftArrow, BiRightArrow } from "react-icons/bi";
import "./Pitches.scss"
const Index = () => {
  const [leadType, setLeadType] = useState("Customer");
  const [accountStatus, setAccountStatus] = useState("Sold");

  const [customerStatus, setCustomerStatus] = useState("Sold");
  const [rating, setRating] = useState(0);
  const [fiberCompanies, setFiberCompanies] = useState([]);
  const [fiberCompanyIds, setFiberCompanyIds] = useState([]);
  const [fiberCompaniesWithName, setFiberCompaniesWithName] = useState([]);
  const [fiberPlans, setFiberPlans] = useState([]);
  const [salesRepIds, setSalesRepIds] = useState([]);
  const [userWithName, setUserWithName] = useState([]);
  const [orgIds, setOrgIds] = useState([]);
  const [orgWithName, setOrgWithName] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [filterBy, setFilterBy] = useState("Customer");
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const [searchString, setSearchString] = useState("");

  const [pitches, setPitches] = useState([]);

  const user = useContext(UserContext);

 

  const GetPitches = async () => {
    let req = {
      AccountStatus: accountStatus,
      SearchString: searchString.trim().toLowerCase(),
      fiberCompanyIds: fiberCompanies,
      orgIds: orgIds,
      repIds: salesRepIds,
      pagingParams: {
        pageNumber: currentPage,
        pageSize: 20,
      },
      customerType: filterBy,
    };  

    let res = await FiberHouseApi.GetPitches(req);

    if (res?.status?.success) {
      setPitches(res.data.list);
      setTotalPages(res.data.totalPages);
      setLoading(false);

      console.log(res.data);
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  useEffect(() => {
    const interval = setTimeout(() => {
      GetPitches();
    }
    , 2000);
    return () => clearTimeout(interval);

  }, [searchString, currentPage, fiberCompanies, orgIds, salesRepIds,filterBy, customerStatus]);






  return (
    <Layout>
      <div className=" p-6 max-w-[1400px] mx-auto pitches">
        {/* <div className="flex flex-wrap justify-between items-center gap-4 mb-6">
          <div className="flex items-center justify-between flex-wrap gap-4">

            {renderSelect(
              "LEAD TYPE",
              leadType,
              ["Customer", "Prospect", "All Leads"],
              setLeadType
            )}

            {leadType !== "All Leads"
              ? renderSelect(
                leadType === "Customer" ? "ACCOUNT STATUS" : "Status",
                accountStatus,
                leadType === "Customer"
                  ? [
                    "Sold",
                    "Sold Only",
                    "Verified Sold",
                    "Pending Installs",
                    "Completed",
                    "Pending Cancels",
                    "Canceled",
                    "Pending Reschedules",
                    "Reviewed",
                    "Missing",
                    "Claw Back",
                    "Paid",
                  ]
                  : ["All", "Offers Sent", "Offers Accepted"],
                setAccountStatus
              )
              : ""}

            {renderSelect(
              "COMPANIES",
              selectedCompany,
              compaies.map(company => company.label),
              setSelectedCompany
            )}

            {renderSelect(
              "ORGANIZATIONS",
              selectedOrg,
              orgs.map(org => org.label),
              setSelectedOrg
            )}

          </div>
        </div> */}

        {/* {
          <div className="relative mb-6">
            <Search
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
              size={20}
            />
            <input
              type="text"
              placeholder="Search"
              value={searchString}
              onChange={(e) => setSearchString(e.target.value)}
              className="pl-10 w-full max-w-sm h-10 rounded-lg border border-gray-200 focus:outline-none focus:border-transparent"
              
            />
          </div>
        } */}
        <div className="SearchFilters">
          <form
            onSubmit={(e) => {
              e.preventDefault();
            }}
            className="search-bar"
          >
            <input
              value={searchString}
              onChange={(e) => {
                setSearchString(e.target.value);
              }}
              type="text"
              placeholder="Search"
            />
            <FaSearch color="#2761CF" size={30} />
          </form>
          <div className="selectors">
            <div className="selector_con">
              <label>Lead Type</label>
              <select
                onChange={(e) => {
                  setFilterBy(e.target.value);
                }}
                className="selector"
                value={filterBy}
              >
                <option value="Customer">Customers</option>
                <option value="Prospect">Hot Leads</option>
                <option value="KnockedDoors">Knocked Doors</option>
                <option value="RequestedCustomer">Requested Customers</option>
                <option value="All">All</option>
              </select>
            </div>
            {filterBy === "Customer" && (
              <div className="selector_con">
                <label>Status</label>
                <select
                  value={customerStatus}
                  onChange={(e) => {
                    setCustomerStatus(e.target.value);
                  }}
                  className="selector"
                >
                  <option value="Sold">Sold</option>
                  <option value="SoldOnly">Sold (Not Scheduled)</option>
                  <option value="VerifiedSold">Verified Sold</option>
                  <option value="PendingInstalls">Pending Installs</option>
                  <option value="Completed">Completed</option>
                  <option value="PendingCancels">Pending Cancels</option>
                  <option value="Canceled">Canceled</option>
                  <option value="PendingReschedules">
                    Pending Reschedules
                  </option>
                  <option value="Referral">Referrals</option>
                  <option value="Reviewed">Reviewed</option>
                  <option value="Missing">Missing</option>
                  <option value="Paid">Payable</option>
                  <option value="ClawBack">Claw Back</option>
                </select>
              </div>
            )}
            {filterBy === "Prospect" && (
              <div className="selector_con">
                <label>Status</label>
                <select
                  value={customerStatus}
                  onChange={(e) => {
                    setCustomerStatus(e.target.value);
                  }}
                  className="selector"
                >
                  0<option value="Prospect">All</option>
                  <option value="OffersSent">Offers Sent</option>
                  <option value="OffersAccepted">Offers Accepted</option>
                </select>
              </div>
            )}
            {customerStatus === "Reviewed" && (
              <div className="selector_con single">
                <label>Rating</label>
                <select
                  value={rating}
                  onChange={(e) => {
                    setRating(parseInt(e.target.value));
                  }}
                  className="selector"
                >
                  <option value="0">All</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
              </div>
            )}
            <FiberCompanySelector
              value={fiberCompanyIds}
              companiesWithOfferTemplateOnly={true}
              className={"single"}
              placeholder="Select Fiber Company"
              multiple={true}
              setCompanyObject={setFiberCompaniesWithName}
              setUser={setFiberCompanies}
              salesOrg={
                user.userType === "SalesOrgAdmin" ? user.salesOrgId : null
              }
              salesRep={user.userType === "SalesRep" ? user : null}
            />
            {user.userType === "SuperAdmin" && (
              <div className="single">
                <div className="select_deselect mb-2">
                  <button
                    className="select"
                    onClick={() => {
                      setOrgWithName([
                        {
                          value: 0,
                          label: "All",
                          id: 0,
                        },
                      ]);
                    }}
                  >
                    Select All
                  </button>
                  <button
                    className="deselect"
                    onClick={() => {
                      setOrgWithName([]);
                    }}
                  >
                    Deselect All
                  </button>
                </div>
                <OrganizationSelector
                  allOption={true}
                  orgWithName={orgWithName}
                  setOrgWithName={setOrgWithName}
                  multiple={true}
                  setUser={setOrgIds}
                  placeholder="Select Organizations"
                  fiberCompaniesIds={fiberCompanies}
                />
              </div>
            )}
            <div className="single">
              <FiberPlanSelector
                userId={user.userType === "SalesRep" ? user.id : null}
                salesOrgId={
                  user.userType === "SalesOrgAdmin" ? user.salesOrgId : null
                }
                placeholder="Select Fiber Plan"
                multiple={true}
                setUser={setFiberPlans}
                fiberCompaniesIds={fiberCompanies}
              />
            </div>
            {(user.userType === "SuperAdmin" ||
              user.userType === "SalesOrgAdmin") && (
              <div className="single">
                <UserSelector
                  fiberCompaniesIds={fiberCompanies}
                  includeDeactivated={true}
                  salesOrgIds={orgIds}
                  includeYourself={true}
                  SalesOrgId={
                    user.userType === "SalesOrgAdmin" ? user.salesOrgId : null
                  }
                  setUser={setSalesRepIds}
                  userWithName={userWithName}
                  setUserWithName={setUserWithName}
                  conversationType={"Group"}
                  placeholder="Select Sales Reps"
                  userTypes={["SalesRep", "SalesOrgAdmin"]}
                />
              </div>
            )}




          </div>
        </div>

        <>
          <div className="border rounded-lg overflow-auto h-[50vh]">
            {
              // loading ?
              //   <div className="flex items-center justify-center h-full">
              //     <VersatileLoader size="large" />
              //   </div>
              //   :

              // name of the lead, address, email, phone number, account status and column which shows an audio player
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-slate-200">
                  <tr>
                    <th className="w-12 px-6 py-3">
                      <input
                        type="checkbox"
                        className="h-4 w-4 rounded border-gray-300 text-blue-600 "
                      />
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Address
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Email
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Phone Number
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Account Status
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Audio
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {pitches.map((pitch, index) => (
                    <tr key={index} className="hover:bg-gray-100">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <input
                          type="checkbox"
                          className="h-4 w-4 rounded border-gray-300 text-blue-600 "
                        />
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">
                          {pitch?.name}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap max-w-60 overflow-hidden">
                        <div className="text-sm text-gray-900">
                          {pitch?.fidiumCustomer?.address}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">
                          {pitch?.email}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">
                          {pitch?.phone}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">
                          {pitch?.fidiumCustomer?.accountStatus}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">
                          {/* <AudioRecorder
                            leadId={pitch.id}
                            pitch={pitch.pitch}
                            setReload={GetPitches}
                          /> */}
                          <audio 
                            controls
                            src={pitch?.pitch?.url}
                            className="w-[300px]"
                            style={{
                              height: "40px",
                              borderRadius: "5px",
                              backgroundColor: "#f1f1f1",
                            }}
                          >
                            Your browser does not support the audio element.
                          </audio>

                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            }
          </div>
          {!loading &&
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "1rem ",
                  }}
                >
                  <Pagination
                    color="light"
                    renderItem={(item) => (
                      <PaginationItem
                        components={{
                          next: (props) => (
                            <button {...props}>
                              <BiRightArrow color="var(--color-icon)" />
                            </button>
                          ),
                          first: (props) => <button {...props}>First</button>,
                          previous: (props) => (
                            <button {...props}>
                              <BiLeftArrow color="var(--color-icon)" />
                            </button>
                          ),
                        }}
                        {...item}
                        sx={{ color: "white" }}
                      />
                    )}
                    count={totalPages}
                    onChange={(e, pageNo) => {
                      setCurrentPage(pageNo);
                    }}
                  />
                </div>
              }
        </>
      </div>
    </Layout>
  );
};

export default Index;
